import React, { Component } from "react";
import { connect } from "react-redux";
import Countly from "countly-sdk-web";

import MemberDashboard from "./MemberDashboard";
import NonMemberDashboard from "./NonMemberDashboard";
import StaffDashboard from "./StaffDashboard";
import EmployerDashboard from "./EmployerDashboard";
import AgentDashboard from "./AgentDashboard";
import historyActions from "../../redux/history/action";

class Home extends Component {
  componentDidMount() {
    const { history, setHistory } = this.props;
    setHistory(history);
    Countly.namespace = "kinexus-countly";
    Countly.q = Countly.q || [];
    Countly.app_key = "150175670469a0bf119d264827bc866faaa14604";

    Countly.url = "https://analytics.kinexus.app";

    Countly.q.push(["track_sessions"]);
    Countly.q.push(["track_scrolls"]);
    Countly.q.push(["track_pageview"]);
    Countly.q.push(["track_clicks"]);
    Countly.q.push(["track_links"]);
    Countly.q.push(["track_forms", null, true]);
    Countly.q.push(["collect_from_forms"]);
    Countly.q.push(["track_errors"]);

    Countly.init();

    const script = document.createElement("script");

    script.async = true;
    script.innerHTML = `(function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = "//alive5.com/js/a5app.js";
      js.setAttribute(
        "data-widget_code_id",
        "00f6fabf-bd26-4c8b-b45c-75c196ce275d"
      );
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "a5widget");`;

    document.body.appendChild(script);
    this.script = script;
  }

  componentWillUnmount() {
    document.body.removeChild(this.script);
  }

  render() {
    let { user, activeDashboard } = this.props;

    if (!activeDashboard && user) {
      activeDashboard = user.primaryRole.roleId;
    }

    if (user) {
      switch (activeDashboard) {
        case 4:
          return <MemberDashboard history={this.props.history} />;
        case 5:
          return <NonMemberDashboard history={this.props.history} />;
        case 1:
          return <StaffDashboard history={this.props.history} />;
        case 2:
          return <EmployerDashboard history={this.props.history} />;
        case 3:
          return <AgentDashboard history={this.props.history} />;
        default:
          return null;
      }
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  activeDashboard: state.dashboard.active,
  localHistory: state.history.localHistory,
});

const mapDispatchToProps = { setHistory: historyActions.setHistory };

export default connect(mapStateToProps, mapDispatchToProps)(Home);
